<template>
  <div class="item-card">
    <div class="row">
      <div class="col">
        <img :src="getImagePath()" @error="fallback" class="item-img" :alt="sold.name">
      </div>
      <div class="col col-right">
        <p>{{sold.name}}</p>
        <p>amount: {{sold.quantity}}</p>
        <p class="price">{{currFormat(sold.price)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sold'],
  data () {
    return {
      onErr: false
    }
  },
  methods: {
    currFormat (currency) {
      return 'Rp. ' + currency.toLocaleString()
    },
    fallback () {
      this.onErr = true
    },
    getImagePath () {
      return (this.onErr) ? 'https://i.imgur.com/0GbE4Oc.jpg' : this.sold.image_URL
    },
    getSubTotal () {
      return this.currFormat(this.sold.quantity * this.sold.price)
    }
  }
}
</script>

<style scoped>
  p {
    margin: 0px;
    padding-left: 5px;
    font-size: 12px;
  }
  .col-right {
    left: -50px;
  }
  .price {
    font-weight: bold;
  }
  .item-card {
    width: 250px;
    box-shadow: 0 0 5px 0px #1e524b;
    margin: 5px 5px;
  }
  .item-card:hover {
    box-shadow: 0 0 5px 1px #1e524b;
  }
  .item-img {
    width: 90px;
    height: 90px;
    box-shadow: 0 0 1px 0px #1e524b;
  }
</style>
